export default [
    {
        path: '/storage/jobs',
        name: 'StorageJobs',
        meta: {
            requiresAuth: true,
            title: 'Storage jobs',
        },
        components: {
            default: () => import('@views/storage/StorageJobsIndex.vue'),
        },
    },
];
